import { useEffect, useState, useContext, Fragment } from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Linking,
  Dimensions,
} from "react-native";
import CustomText from "../accessories/CustomText";
import {
  handleLogDWCallToActionEventParent,
  updateWebURL,
  handleStartNewLoan,
  queryStringToObject,
  generateBoxShadowStyle,
  log,
} from "../accessories/CommonFunctions";
import FontAwesome from "react-native-vector-icons/FontAwesome";
import Entypo from "react-native-vector-icons/Entypo";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import { Separator, context } from "../accessories/accessories";
import { web, android } from "../accessories/Platform";

const isMobileWeb = Dimensions.get("window").width <= 480 && web;

const loanKeyDetails = [
  {
    label: "Loan Program:",
    key: "LoanProgram",
    check: true,
  },
  {
    label: "Loan Amount:",
    key: "LoanAmount",
  },
  {
    label: "Interest Rate:",
    key: "IntRate",
    check: true,
  },
  {
    label: "Payment:",
    key: "Piti",
    check: true,
  },
  {
    label: "Loan #:",
    key: "LoanId",
  },
  {
    label: "Status:",
    key: "UWStatus",
  },
];

const RecentLoans = (props) => {
  const [screenSize, setScreenSize] = useState(
      web ? [window.innerWidth, window.innerHeight] : [0, 0]
    ),
    width = Dimensions.get("window").width,
    isSmallScreen = (web && screenSize[0] > 900) || width > 900;

  const { contextDetails, setContextDetails } = useContext(context); //Get value from context
  const [loanCount, setLoanCount] = useState(10);
  const { SessionId, navigation, userName = "" } = contextDetails;
  const {
    recentLoans: iRecentLoans,
    isExpand,
    setFloatPage = () => {},
  } = props;
  const [recentLoans, setRecentLoans] = useState(iRecentLoans || []);
  const [currentLoanDetails, setCurrentLoanDetails] = useState({
    isExpand: isExpand || false,
  });
  useEffect(() => {
    if (iRecentLoans.length > 0) {
      setContextDetails({
        ...contextDetails,
        RecentLoId: iRecentLoans[0].RecentLoId,
      });
      setRecentLoans(iRecentLoans);
    } else {
      setRecentLoans([]);
    }
  }, [iRecentLoans]);

  useEffect(() => {
    setCurrentLoanDetails({ isExpand });
  }, [isExpand]);

  const navigate = (path, option) => {
    updateWebURL({ ...option, Path: path });
    (navigation || props["navigation"]).navigate(path, option || {});
  };
  const ButtonContinue = (row) => {
    return (
      <TouchableOpacity
        activeOpacity={1}
        style={[
          {
            marginBottom: 5,
            paddingHorizontal: 5,
            paddingVertical: 10,
            color: "#fff",
            alignSelf: "stretch",
            alignItems: "center",
            borderRadius: 5,
            borderWidth: 1,
            borderColor: "#4f77a9",
            backgroundColor: "#5b8bc8",
            shadowColor: "rgba(0, 0, 0, 0.30)",
            shadowRadius: 10,
            shadowOpacity: 0.8,
            ...generateBoxShadowStyle(2, 4, "black", 0.3, 3, 8, "black"),
          },
          web ? { boxShadow: "#0000003d 0px 4px 10px 1px" } : {},
        ]}
        onPress={() => {
          setContextDetails({ ...contextDetails, loanId: row["LoanId"] });
          navigate("Home");
          handleLogDWCallToActionEventParent(
            "Continue",
            "fnLogDWCallToActionEvent",
            "Borrower Loan Application",
            {
              SessionId,
              Email: "",
              LoanId: row["LoanId"],
              LoanOfficerId: web
                ? queryStringToObject(window.location?.href || "")[
                    "loanOfficerId"
                  ] ||
                  contextDetails.RecentLoId ||
                  0
                : contextDetails.RecentLoId || 0,
              Email: contextDetails["Email"],
            }
          );
          updateWebURL({
            // FormId: FormId,
            loanId: row["LoanId"],
            Path: "Home",
          });
        }}
      >
        <View style={{ flex: 1, flexDirection: "row" }}>
          <CustomText
            style={{ color: "#fff", marginTop: -2, fontSize: 12 }}
            bold={true}
          >
            Continue Application
          </CustomText>
        </View>
      </TouchableOpacity>
    );
  };
  const StartNewLoan = () => {
    return (
      <TouchableOpacity
        activeOpacity={1}
        onPress={() => {
          handleLogDWCallToActionEventParent(
            "Start a New Loan Application",
            "fnLogDWCallToActionEvent",
            "Borrower Loan Application",
            {
              SessionId,
              Email: "",
              LoanId: 0,
              LoanOfficerId: web
                ? queryStringToObject(window.location?.href || "")[
                    "loanOfficerId"
                  ] ||
                  contextDetails.RecentLoId ||
                  0
                : contextDetails.RecentLoId || 0,
              Email: contextDetails["Email"],
            }
          );
          handleStartNewLoan(
            navigation || props["navigation"],
            SessionId,
            userName,
            contextDetails,
            setContextDetails
          );
        }}
        style={[
          {
            backgroundColor: "#1a63ad",
            borderRadius: 5,
            borderWidth: 1,
            alignSelf: "left",
            paddingHorizontal: 15,
            paddingVertical: 8,
            marginRight: 0,
            borderColor: "#262626",
            backgroundColor: "#595959",
            width: web ? "fit-content" : "auto",
          },
        ]}
      >
        <CustomText
          bold={true}
          style={{
            color: "#fff",
            fontSize: android ? 12 : 15,
          }}
        >
          Start a New Loan
        </CustomText>
      </TouchableOpacity>
    );
  };
  const ButtonReviewLoan = ({ loanId }) => {
    return (
      <TouchableOpacity
        activeOpacity={1}
        onPress={() => {
          try {
            setContextDetails({
              ...contextDetails,
              loanId: loanId || -99,
            });
            let params = {
              FormId: 34,
              loanId: loanId || -99,
              Path: "Home",
              GoToNav: 10,
            };
            (navigation || props["navigation"]).navigate("Home", params);
            if (web) updateWebURL(params);
            handleLogDWCallToActionEventParent(
              "Review Loan Disclosures",
              "fnLogDWCallToActionEvent",
              "Borrower Loan Application",
              {
                SessionId,
                Email: "",
                LoanId: loanId || -99,
                LoanOfficerId: web
                  ? queryStringToObject(window.location?.href || "")[
                      "loanOfficerId"
                    ] ||
                    contextDetails.RecentLoId ||
                    0
                  : contextDetails.RecentLoId || 0,
                Email: contextDetails["Email"],
              }
            );
          } catch (e) {}
        }}
        style={[
          {
            paddingHorizontal: 5,
            paddingVertical: 10,
            color: "#fff",
            alignSelf: "stretch",
            alignItems: "center",
            borderRadius: 5,
            borderWidth: 1,
            borderColor: "#262626",
            backgroundColor: "#595959",
            shadowColor: "rgba(0, 0, 0, 0.30)",
            shadowRadius: 10,
            shadowOpacity: 0.8,
            ...generateBoxShadowStyle(2, 4, "black", 0.3, 3, 8, "black"),
          },
          web
            ? { boxShadow: "#0000003d 0px 4px 10px 1px", cursor: "pointer" }
            : {},
        ]}
      >
        <CustomText style={{ color: "#fff", fontSize: 12 }} bold={true}>
          Review Loan Disclosures
        </CustomText>
      </TouchableOpacity>
    );
  };

  const ButtonMakePayment = (row) => {
    return (
      <View
        style={{
          flex: 1,
          marginTop: 10,
          width: 170,
          alignSelf: "flex-end",
          marginBottom: -10,
          marginRight: 10,
        }}
      >
        <TouchableOpacity
          activeOpacity={1}
          style={{
            flex: 1,
            flexDirection: "row",
            alignItems: "stretch",
            backgroundColor: "#5bb15b",
            borderRadius: 20,
            paddingHorizontal: 10,
            paddingVertical: 10,
            borderWidth: 1,
            borderColor: "#29916c",
          }}
          onPress={() => {
            // setContextDetails({ ...contextDetails, loanId: row["LoanId"] });
            // navigate("Home");
            handleLogDWCallToActionEventParent(
              "Continue",
              "fnLogDWCallToActionEvent",
              "Borrower Loan Application",
              {
                SessionId,
                Email: "",
                LoanId: row["LoanId"],
                LoanOfficerId: web
                  ? queryStringToObject(window.location?.href || "")[
                      "loanOfficerId"
                    ] ||
                    contextDetails.RecentLoId ||
                    0
                  : contextDetails.RecentLoId || 0,
                Email: contextDetails["Email"],
              }
            );
            // updateWebURL({
            //   // FormId: FormId,
            //   loanId: row["LoanId"],
            //   Path: "Home",
            // });
            if (web) {
              // setFloatPage({
              //   path: "Calculator",
              //   option: {
              //     From: "CalculatorMenu",
              //     type: item["type"],
              //     LoanId,
              //     style: {
              //       minHeight: "75vh",
              //     },
              //   },
              // });
            } else {
              (navigation || props["navigation"]).navigate("Payment", {
                From: "DashBoard",
                LoanId: row["LoanId"],
              });
            }
          }}
        >
          <View style={{ flex: 1, flexDirection: "row" }}>
            <CustomText style={{ color: "#fff", marginTop: -2 }} bold={true}>
              Make a Payment
            </CustomText>
          </View>
        </TouchableOpacity>
      </View>
    );
  };

  return (
    <>
      <View style={styles.webWrapper}>
        <View
          style={[
            {
              //  width: !isMobileWeb && web ? 700 : "100%",
              width:
                isMobileWeb && web
                  ? "inherit"
                  : web
                  ? 700
                  : isSmallScreen && !web
                  ? 700
                  : "100%",
              backgroundColor: "lightgray",
              flexDirection: "row",
              marginTop: 25,
              justifyContent: isMobileWeb ? "flex-start" : "space-between",
              alignItems: isMobileWeb && web ? "left" : "center",
              borderRadius: 5,
              height: isMobileWeb && web ? "fit-content" : "auto",
            },
          ]}
        >
          <TouchableOpacity
            activeOpacity={0.7}
            style={[
              {
                fontSize: android ? 18 : !isMobileWeb && web ? 25 : 15,
                paddingVertical: 10,
                paddingHorizontal: 10,
                flex: 1,
                flexDirection: "row",
              },
              web
                ? {
                    display: "flex",
                    cursor: "pointer",
                  }
                : {},
            ]}
            onPress={() => {
              setCurrentLoanDetails((prevCurrentLoanDetails) => {
                const { isExpand } = prevCurrentLoanDetails;
                return { ...prevCurrentLoanDetails, isExpand: !isExpand };
              });
            }}
          >
            <View
              style={[
                {
                  alignSelf: "center",
                  justifyContent: "center",
                  marginRight: 5,
                  minWidth: web ? 18 : 11,
                },
                web ? { alignSelf: "center", display: "flex" } : {},
              ]}
            >
              <FontAwesome
                name={`chevron-${
                  !currentLoanDetails["isExpand"] ? "right" : "down"
                }`}
                size={web ? 18 : 11}
              />
            </View>
            <CustomText
              style={{
                fontSize: !isMobileWeb && web ? 25 : 15,
              }}
              bold={true}
            >
              Current & Previous Loans{" "}
            </CustomText>
            <CustomText
              style={{
                backgroundColor: "#6aa0d7",
                borderRadius: 4,
                // color: "rgb(66, 126, 203)",
                color: "black",
                fontSize: 12,
                minWidth: 20,
                maxWidth: 20,
                minHeight: web ? 25 : 20,
                display: "flex",
                overflow: "hidden",
                flex: 1,
                justifyContent: "center",
                alignSelf: "center",
                alignItems: "center",
                textAlign: "center",
              }}
              bold={true}
            >
              {(recentLoans || []).length}
            </CustomText>
          </TouchableOpacity>
        </View>
        {currentLoanDetails["isExpand"] && (
          <View
            style={[
              web && !isMobileWeb && { flexFlow: "wrap" },
              { marginBottom: 30 },
            ]}
          >
            {[...recentLoans].slice(0, loanCount).map((row, index) => {
              const isLoanProductSelected = Boolean(row["LoanProgram"]);
              return (
                <View
                  key={index}
                  style={[
                    styles.container,
                    generateBoxShadowStyle(2, 3, "black", 0.2, 3, 8, "black"),
                    {
                      shadowColor: "rgba(0, 0, 0, 0.30)",
                      shadowRadius: 10,
                      shadowOpacity: 0.8,
                      justifyContent: "space-between",
                      width: web ? 340 : isSmallScreen && !web ? 450 : "96%",
                      marginRight:
                        (isMobileWeb || !web) && width < 451 ? 0 : 20,
                      alignSelf:
                        (isMobileWeb || !web) && width < 451
                          ? "center"
                          : "stretch",
                    },
                  ]}
                >
                  <View>
                    <View style={styles.property}>
                      <CustomText
                        bold={true}
                        style={{
                          fontSize: web ? 18 : 14,
                          color: "#323337",
                          lineHeight: 20,
                          maxWidth: ["Funded", "Closed"].includes(
                            row["LoanStatus"]
                          )
                            ? "100%"
                            : "45%",
                        }}
                      >
                        {`${row["SubjectAddress"]}${
                          row["SubjectCity"]
                            ? `${"\n"}${row["SubjectCity"]}`
                            : ""
                        } ${row["SubjectState"]}${
                          row["SubjectZip"] ? ` ${row["SubjectZip"]}` : ""
                        }`}
                      </CustomText>
                      {Number(row["Active"]) === 1 &&
                        (row["LoanStatus"] === "Closed" ||
                        row["LoanStatus"] === "Funded" ? (
                          // <ButtonMakePayment {...row} /> //enable once payment page is done and route to payment page
                          <></>
                        ) : (
                          <View
                            style={{
                              flexDirection: "column",
                              width: web ? "55%" : "50%",
                            }}
                          >
                            {/* If LoanStatus is not Closed, set justifyContent to "center"
                       You can modify the condition or the value based on your specific logic */}
                            <ButtonContinue {...row} />

                            {row["EsignExist"] && (
                              <ButtonReviewLoan loanId={row["LoanId"]} />
                            )}
                          </View>
                        ))}
                    </View>
                    <View style={{ paddingHorizontal: 15 }}>
                      {loanKeyDetails.map(
                        ({ label, key, check = false }, index) => {
                          return (
                            <Fragment key={key}>
                              {isLoanProductSelected || !check ? (
                                <View style={styles.row}>
                                  <CustomText
                                    style={{
                                      fontSize: web ? 16 : 14,
                                      flex: 1.3,
                                    }}
                                    bold={true}
                                  >
                                    {label}
                                  </CustomText>
                                  <CustomText
                                    style={{
                                      fontSize: web ? 16 : 14,
                                      flex: 2,
                                    }}
                                  >
                                    {row[key]}
                                  </CustomText>
                                </View>
                              ) : (
                                <></>
                              )}
                            </Fragment>
                          );
                        }
                      )}
                      {row["DMCServicer"] == 1 &&
                        row["LoanStatus"] === "Funded" && (
                          <View
                            style={{
                              flexDirection: "row",
                              padding: 8,
                              backgroundColor: "#dce8f4",
                              borderRadius: 5,
                              marginVertical: 10,
                            }}
                          >
                            <View style={{ flex: 1.3 }}>
                              <CustomText
                                style={{
                                  fontSize: web ? 16 : 14,
                                  flex: 1.2,
                                }}
                                bold={true}
                              >
                                Payment Information:
                              </CustomText>
                            </View>
                            <View style={{ flex: 2 }}>
                              <View style={[styles["paymentRow"]]}>
                                <CustomText
                                  style={[styles["paymentRowCellOne"]]}
                                  bold={true}
                                >
                                  Due date:
                                </CustomText>
                                <CustomText
                                  bold
                                  style={[styles["paymentRowCellTwo"]]}
                                >
                                  {row["paymentDueDate"]}
                                </CustomText>
                              </View>
                              <View style={[styles["paymentRow"]]}>
                                <CustomText
                                  style={[styles["paymentRowCellOne"]]}
                                  bold={true}
                                >
                                  Amount:
                                </CustomText>
                                <CustomText
                                  bold
                                  style={[styles["paymentRowCellTwo"]]}
                                >
                                  {row["paymentAmount"]}
                                </CustomText>
                              </View>
                              <View style={[styles["paymentRow"]]}>
                                <CustomText
                                  style={[styles["paymentRowCellOne"]]}
                                  bold={true}
                                >
                                  Remaining Term:
                                </CustomText>
                                <CustomText
                                  bold
                                  style={[styles["paymentRowCellTwo"]]}
                                >
                                  {row["paymentsRemaining"]}
                                </CustomText>
                              </View>
                              <View style={[styles["paymentRow"]]}>
                                <CustomText
                                  style={[styles["paymentRowCellOne"]]}
                                  bold={true}
                                >
                                  Balance:
                                </CustomText>
                                <CustomText
                                  bold
                                  style={[styles["paymentRowCellTwo"]]}
                                >
                                  {row["remainingBalance"]}
                                </CustomText>
                              </View>
                              <TouchableOpacity
                                activeOpacity={1}
                                style={[
                                  {
                                    marginVertical: 5,
                                    paddingHorizontal: 10,
                                    paddingVertical: 5,
                                    flex: 1,
                                    color: "#fff",
                                    alignSelf: "flex-start",
                                    alignItems: "center",
                                    borderRadius: 5,
                                    borderWidth: 1,
                                    borderColor: "#4f77a9",
                                    backgroundColor: "#5b8bc8",
                                    shadowColor: "rgba(0, 0, 0, 0.30)",
                                    shadowRadius: 10,
                                    shadowOpacity: 0.8,
                                    ...generateBoxShadowStyle(
                                      2,
                                      4,
                                      "black",
                                      0.3,
                                      3,
                                      8,
                                      "black"
                                    ),
                                  },
                                  web
                                    ? {
                                        boxShadow: "#0000003d 0px 4px 10px 1px",
                                      }
                                    : {},
                                ]}
                                onPress={() => {
                                  if (web) {
                                    setFloatPage({
                                      path: "Payment",
                                      option: {
                                        From: "DashBoard",
                                        LoanId: row["LoanId"],
                                        SessionId,
                                        UserId: 0,
                                        style: {
                                          minHeight: "75vh",
                                        },
                                      },
                                    });
                                  } else {
                                    (
                                      navigation || props["navigation"]
                                    ).navigate("Payment", {
                                      From: "DashBoard",
                                      LoanId: row["LoanId"],
                                      SessionId,
                                      UserId: 0,
                                    });
                                  }
                                }}
                              >
                                <View style={{ flex: 1, flexDirection: "row" }}>
                                  <CustomText
                                    style={{
                                      color: "#fff",
                                      marginTop: -2,
                                      fontSize: 12,
                                    }}
                                    bold={true}
                                  >
                                    Make a Payment
                                  </CustomText>
                                </View>
                              </TouchableOpacity>
                            </View>
                          </View>
                        )}
                      <View>
                        <View style={{ marginBottom: 5 }}>
                          <CustomText
                            style={{ fontSize: web ? 16 : 14, flex: 1 }}
                            bold={true}
                          >
                            Loan Officer:
                          </CustomText>
                        </View>
                        <View style={{ marginBottom: 5 }}>
                          <CustomText style={{ fontSize: 16 }}>
                            {row["LoName"]}
                          </CustomText>
                        </View>
                        <View style={{ marginBottom: 5 }}>
                          <CustomText
                            style={{ fontSize: web ? 16 : 14, flex: 1 }}
                            onPress={() => {
                              let phoneNumber = row["LoPhone"]
                                ?.replaceAll("-", "")
                                .replaceAll("(", "")
                                .replaceAll(")", "")
                                .replaceAll(" ", "");

                              phoneNumber = `tel://${phoneNumber}`;

                              Linking.canOpenURL(phoneNumber)
                                .then((supported) => {
                                  if (!supported) {
                                    console.log(
                                      "Phone number is not available"
                                    );
                                  } else {
                                    return Linking.openURL(phoneNumber);
                                  }
                                })
                                .catch((err) => console.log(err));
                            }}
                          >
                            <MaterialCommunityIcons
                              name="phone"
                              size={web ? 20 : 18}
                            />
                            <CustomText style={{ color: "#2971bf", flex: 1 }}>
                              {" "}
                              {row["LoPhone"]}
                            </CustomText>
                          </CustomText>
                        </View>
                        <View style={{ marginBottom: 5 }}>
                          <CustomText
                            style={{ fontSize: web ? 16 : 14, flex: 1 }}
                            onPress={() => {
                              let subject = "",
                                body = "";
                              const emailUrl = `mailto:${
                                row["LoEmail"]
                              }?subject=${encodeURIComponent(
                                subject
                              )}&body=${encodeURIComponent(body)}`;
                              Linking.openURL(emailUrl);
                            }}
                          >
                            <MaterialCommunityIcons
                              name="email"
                              size={web ? 20 : 18}
                            />
                            <CustomText style={{ color: "#2971bf", flex: 1 }}>
                              {" "}
                              {row["LoEmail"]}
                            </CustomText>
                          </CustomText>
                        </View>
                      </View>
                    </View>
                  </View>
                </View>
              );
            })}
            <TouchableOpacity
              activeOpacity={0.7}
              style={[
                generateBoxShadowStyle(3, 3, "black", 0.2, 3, 8, "black"),
                {
                  shadowColor: "rgba(0, 0, 0, 0.30)",
                  shadowRadius: 10,
                  shadowOpacity: 0.8,
                  justifyContent: "space-between",
                  width: web ? 340 : isSmallScreen && !web ? 450 : "96%",
                  marginRight: (isMobileWeb || !web) && width < 451 ? 0 : 20,
                  alignSelf:
                    (isMobileWeb || !web) && width < 451 ? "center" : "stretch",
                  minHeight: 460,
                  maxHeight: !web ? 475 : "auto",
                  backgroundColor: "#F2F2F2",
                  paddingVertical:
                    (isMobileWeb || !web) && width < 451 ? "18%" : "10%",
                  paddingHorizontal:
                    !web && width < 451 ? "20%" : isMobileWeb ? "16%" : "8%",
                  alignItems: "center",
                  borderWidth: 1.5,
                  borderColor: "#e4e6e9",
                  borderRadius: 6,
                  marginTop: 20,
                },
              ]}
              onPress={() => {
                handleLogDWCallToActionEventParent(
                  "Start a New Loan Application",
                  "fnLogDWCallToActionEvent",
                  "Borrower Loan Application",
                  {
                    SessionId,
                    Email: "",
                    LoanId: 0,
                    LoanOfficerId: web
                      ? queryStringToObject(window.location?.href || "")[
                          "loanOfficerId"
                        ] ||
                        contextDetails.RecentLoId ||
                        0
                      : contextDetails.RecentLoId || 0,
                    Email: contextDetails["Email"],
                  }
                );
                handleStartNewLoan(
                  navigation || props["navigation"],
                  SessionId,
                  userName,
                  contextDetails,
                  setContextDetails
                );
              }}
            >
              <View
                style={{
                  width: "100%",
                  height: "100%",
                  alignSelf: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#e6e6e6",
                  borderColor: "#c9c9ca",
                  borderRadius: 10,
                  borderWidth: 2,
                  paddingHorizontal: 30,
                }}
              >
                <Entypo name="plus" size={35} />
                <CustomText
                  bold={true}
                  style={{ fontSize: 30, textAlign: "center" }}
                >
                  Start a New Loan
                </CustomText>
              </View>
            </TouchableOpacity>
          </View>
        )}
      </View>
      <>
        {recentLoans.length - loanCount > 0 && (
          <View
            style={{
              flex: 1,
              marginTop: 10,
              width: 240,
            }}
          >
            <TouchableOpacity
              activeOpacity={1}
              onPress={() => setLoanCount(loanCount + 10)}
              style={[
                {
                  paddingHorizontal: 10,
                  paddingVertical: 10,
                  color: "#fff",
                  borderRadius: 5,
                  borderWidth: 1,
                  borderColor: "#4f77a9",
                  backgroundColor: "#5b8bc8",
                  shadowColor: "rgba(0, 0, 0, 0.30)",
                  shadowRadius: 10,
                  shadowOpacity: 0.8,
                  ...generateBoxShadowStyle(2, 4, "black", 0.3, 3, 8, "black"),
                },
                web ? { boxShadow: "#0000003d 0px 4px 10px 1px" } : {},
              ]}
            >
              <View style={{ flex: 1, flexDirection: "row" }}>
                <CustomText
                  style={{ color: "#fff", marginTop: -3 }}
                  bold={true}
                >
                  View {recentLoans.length - loanCount} more previous loans...
                </CustomText>
              </View>
            </TouchableOpacity>
          </View>
        )}
      </>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 1.5,
    borderColor: "#e4e6e9",
    borderRadius: 6,
    alignSelf: "flex-start",
    backgroundColor: "#fff",
    paddingBottom: 20,
    marginTop: 20,
    alignSelf: "center",
    position: "relative",
  },
  property: {
    marginHorizontal: 15,
    marginVertical: 10,
    paddingHorizontal: 10,
    paddingVertical: 10,
    borderRadius: 6,
    backgroundColor: "lightgray",
    marginBottom: 20,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  buttonContainer: {
    backgroundColor: "#1a63ad",
    borderRadius: 25,
    height: 35,
    paddingVertical: web ? 10 : 8,
    paddingHorizontal: 10,
    marginTop: 20,
    //paddingTop: web ? "5px" : null,
    alignSelf: "flex-start",
  },
  paymentRow: { flexDirection: "row", justifyContent: "space-between" },
  paymentRowCellOne: {
    fontSize: web ? 13 : 11,
  },
  paymentRowCellTwo: {
    fontSize: web ? 14 : 12,
  },
  row: { flexDirection: "row", marginBottom: 10 },
  webWrapper: web
    ? {
        // display: "grid",
        // "grid-template-columns": "repeat(auto-fit,minmax(345px,1fr))",
        // "grid-gap": "10",
        // width: "calc(100% - 256px)",
        width: isMobileWeb ? "100%" : 740,
        display: isMobileWeb ? "flex" : "inline-flex",
        "flex-wrap": "wrap",
        marginBottom: 20,
      }
    : {},
});

export default RecentLoans;
